/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Welcome_Suggestion_Reusable_WorkspacesInputs */



/**
* | output |
* | --- |
* | "Set up my first project" |
*
* @param {Uno_Welcome_Suggestion_Reusable_WorkspacesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_suggestion_reusable_workspaces = /** @type {((inputs?: Uno_Welcome_Suggestion_Reusable_WorkspacesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_Suggestion_Reusable_WorkspacesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mein erstes Projekt einrichten")
	return /** @type {LocalizedString} */ ("Set up my first project")
});